import { render, staticRenderFns } from "./a-textarea.vue?vue&type=template&id=5821da45&"
import script from "./a-textarea.vue?vue&type=script&lang=js&"
export * from "./a-textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports